import React from 'react';
import { deviceDialNumber, formatDialPhone } from '../utils/crmPhone';

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M7.1 2.8 9.6 8 7.9 9.7a15.2 15.2 0 0 0 6.4 6.4l1.7-1.7 5.2 2.5v3.2c0 .6-.5 1.1-1.1 1.1A17.3 17.3 0 0 1 2.8 3.9c0-.6.5-1.1 1.1-1.1h3.2Z" />
  </svg>
);

const CrmDeviceDialDialog = ({ contact, onClose }) => {
  const dialNumber = deviceDialNumber(contact);
  if (!contact || !dialNumber) return null;

  return (
    <div className="modal-overlay crm-device-dial-overlay" onClick={onClose}>
      <div
        className="modal-content crm-device-dial-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="device-dial-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="modal-header crm-device-dial-header">
          <div className="crm-device-dial-title-row">
            <span className="crm-device-dial-icon" aria-hidden="true"><PhoneIcon /></span>
            <div>
              <h3 id="device-dial-title">Call with phone dialer</h3>
              <p className="crm-device-dial-subtitle">Standard mobile call outside CRM</p>
            </div>
          </div>
          <button type="button" className="modal-close" aria-label="Close" onClick={onClose}>×</button>
        </div>

        <div className="crm-device-dial-body">
          <div className="crm-device-dial-contact">
            <span className="crm-device-dial-avatar" aria-hidden="true">
              {(contact.name || 'U').trim().charAt(0).toUpperCase()}
            </span>
            <span className="crm-device-dial-contact-copy">
              <span className="crm-device-dial-name">{contact.name || 'Unnamed contact'}</span>
              <span className="crm-device-dial-phone">{formatDialPhone(contact.phone)}</span>
            </span>
          </div>
          <p className="crm-device-dial-prompt">
            This contact is not registered in the app, so CRM calling is unavailable.
            You can still call using your phone&apos;s dialer.
          </p>
          <div className="crm-device-dial-note">
            <span className="crm-device-dial-note-icon" aria-hidden="true">i</span>
            <span>The number is prefilled. The call is not masked or automatically logged in CRM.</span>
          </div>
        </div>

        <div className="modal-footer crm-device-dial-footer">
          <button type="button" className="btn btn-secondary crm-device-dial-cancel" onClick={onClose}>
            Cancel
          </button>
          <a className="btn btn-success crm-device-dial-cta" href={`tel:${dialNumber}`} onClick={onClose}>
            <PhoneIcon />
            Open phone dialer
          </a>
        </div>
      </div>
    </div>
  );
};

export default CrmDeviceDialDialog;
